import { IMessageListItemV2Schema } from '../repositories/chats/entities/message_list_item_v2/MessageListItemV2Schema';
import { TMessageSchema } from '../types/messages';

export const mapMessage = (message: IMessageListItemV2Schema): TMessageSchema => {
  return {
    ...message,
    unread: message.status !== 'readByRecipient',
    type: message.type,
  };
};
